export enum Step {
  Type = 'type',
  UploadImage = 'upload-image',
  ReleaseInfo = 'release-info',
  TrackUpload = 'track-upload',
  TrackInfo = 'track-info',
  Publish = 'publish',
  Platform = 'platform',
  paidPlatform = 'paidPlatform'
}
